/**
 * Markdown Formatter
 * Converts markdown-like text to HTML
 *
 * @module MarkdownFormatter
 * Sprint 32: OOA/OOD Refactoring
 */

/**
 * Format markdown-like content to HTML
 */
export function formatMarkdown(text: string): string {
    return text
        // Headings (must be processed in order: most specific first)
        .replace(/^#### (.+)$/gm, '<h5 class="text-sm font-semibold mt-2 mb-1">$1</h5>')
        .replace(/^### (.+)$/gm, '<h4 class="text-md font-semibold mt-3 mb-1">$1</h4>')
        .replace(/^## (.+)$/gm, '<h3 class="text-lg font-semibold mt-4 mb-2">$1</h3>')
        .replace(/^# (.+)$/gm, '<h2 class="text-xl font-bold mt-4 mb-2">$1</h2>')
        // Text formatting
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/`(.+?)`/g, '<code class="bg-gray-200 px-1 rounded text-sm">$1</code>')
        // Line breaks (after headings are processed)
        .replace(/\n/g, '<br>');
}

/**
 * Unescape literal escape sequences from Candid parsing
 * Converts \n to newline, \' to apostrophe, etc.
 */
export function unescapeString(text: string): string {
    if (!text) return text;
    return text
        .replace(/\\n/g, '\n')      // Literal \n to newline
        .replace(/\\r/g, '\r')      // Literal \r to carriage return
        .replace(/\\t/g, '\t')      // Literal \t to tab
        .replace(/\\'/g, "'")       // Literal \' to apostrophe
        .replace(/\\"/g, '"')       // Literal \" to double quote
        .replace(/\\\\/g, '\\');    // Literal \\ to single backslash
}

/**
 * Truncate text to a maximum length with ellipsis
 */
export function truncateText(text: string, maxLength: number): string {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength - 3) + '...';
}

/**
 * Strip HTML tags from text
 */
export function stripHtml(text: string): string {
    return text.replace(/<[^>]*>/g, '');
}
